import React from 'react';
import { useNavigate } from 'react-router-dom';

const Ambulance = () => {
    const navigate = useNavigate();
    const phoneNumber = "9900202606";

    const handleCall = () => {
        window.location.href = `tel:${phoneNumber}`;
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-[80vh] p-6 text-center">
            <div className="bg-gray-800 p-8 rounded-3xl shadow-2xl w-full max-w-md">
                <div className="w-20 h-20 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg className="w-10 h-10 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                    </svg>
                </div>

                <h1 className="text-2xl font-bold text-white mb-2">Emergency Assistance</h1>
                <p className="text-gray-400 mb-8">Click the button below to call for immediate assistance.</p>

                <button
                    onClick={handleCall}
                    className="w-full bg-yellow-500 hover:bg-amber-600 text-white font-bold py-4 rounded-xl text-xl shadow-lg transition-transform active:scale-95 flex items-center justify-center gap-3"
                >
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                    </svg>
                    Call Now
                </button>

                <div className="mt-8 pt-8 border-t border-gray-700">
                    <p className="text-gray-500 text-[10px] leading-relaxed italic">
                        *Terms and conditions applied. This service is for emergency ambulance requests only.
                        Availability may vary depending on location and current service infrastructure.
                    </p>
                </div>
            </div>

            <button
                onClick={() => navigate(-1)}
                className="mt-8 text-gray-400 hover:text-white transition-colors flex items-center gap-2"
            >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Go Back
            </button>
        </div>
    );
};

export default Ambulance;
